export type BrokerNerdsBarkerCoreEnumsShowWeather = (typeof BrokerNerdsBarkerCoreEnumsShowWeather)[keyof typeof BrokerNerdsBarkerCoreEnumsShowWeather];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsShowWeather = {
  Never: 'Never',
  Always: 'Always',
  OnlyImportant: 'OnlyImportant',
} as const;
